export default function majIntervenant(intervenant, contactClient) {
  let client = contactClient;
  let contact = null;
  if (contactClient.client) {
    client = contactClient.client;
  }
  if (contactClient.contact) {
    contact = contactClient.contact;
    intervenant.contactId = contact?.id;
    intervenant.contact = contact;

    // gestion multi contact
    intervenant.intervenantContacts = [{
      contactId: contact?.id,
      contact: contact,
      contactTypes: contact?.typesContactIds?.map(tc => { return { typeContactId: tc }; }) ?? [],
    }];
  }
  intervenant.nomCommercial = contactClient.nomCommercial;
  if (contact && contact.adresseContactDifferente) {
    intervenant.adressePostale = contact.adresse;
  } else {
    intervenant.adressePostale = client.adressePostale;
    if (client.adresseFacturationDifferente) {
      intervenant.adressePostale = client.adresseFacturation;
    }
  }
  intervenant.tiers = contactClient;
  intervenant.modeReglementId = client.modeReglementId;
  intervenant.modeReglement = client.modeReglement;
  intervenant.delaiReglementId = client.delaiReglementId;
  intervenant.delaiReglement = client.delaiReglement;
  intervenant.delaiReglementDetail = client.delaiReglementDetail;
  intervenant.tiersId = client.id;
  intervenant.compteComptable = client.compteComptable;
  intervenant.applicationTva = client.applicationTva;
  intervenant.tvaIntracommunautaire = client.tvaIntracommunautaire;
  intervenant.siret = client.siret;
}
